'use strict'
import { request } from '../../plugins/http'

export default async (productId) => {
    return await request.delete('/produto', {params:{id:productId}})
}